import { activeHoliday, iconMarkup } from "./holidays";

export const DEFAULT_PAW_COLOR = "#9333EA";

export const PAW_PRESETS = [
  { name: "Lavender", color: "#9333EA" },
  { name: "Pink", color: "#EC4899" },
  { name: "Holiday red", color: "#DC2626" },
  { name: "Evergreen", color: "#16A34A" },
  { name: "Autumn", color: "#EA580C" },
  { name: "Winter blue", color: "#2563EB" },
  { name: "Gold", color: "#CA8A04" },
  { name: "Charcoal", color: "#1C1917" },
];

export const pawOpacity = (intensity) => {
  const v = Math.max(0, Math.min(100, Number(intensity ?? 50)));
  return (v / 100) * 0.5;
};

const PAW = "<ellipse cx='0' cy='52' rx='64' ry='54'/><ellipse cx='-62' cy='-18' rx='24' ry='32' transform='rotate(-20 -62 -18)'/><ellipse cx='-22' cy='-54' rx='24' ry='32' transform='rotate(-6 -22 -54)'/><ellipse cx='24' cy='-54' rx='24' ry='32' transform='rotate(6 24 -54)'/><ellipse cx='64' cy='-18' rx='24' ry='32' transform='rotate(20 64 -18)'/>";

export const normalizePawColor = (color) => (/^#[0-9a-fA-F]{6}$/.test(color || "") ? color : DEFAULT_PAW_COLOR);

export const pawPattern = (color, icon) => {
  const fill = normalizePawColor(color);
  const extras = icon
    ? `<g transform='translate(470 150) rotate(-10) scale(5.2) translate(-12 -12)'>${iconMarkup(icon)}</g><g transform='translate(150 470) rotate(14) scale(4.4) translate(-12 -12)'>${iconMarkup(icon)}</g>`
    : "";
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='640' height='640' viewBox='0 0 640 640' color='${fill}'><g fill='${fill}'><g transform='translate(150 170) rotate(-18)'>${PAW}</g><g transform='translate(470 470) rotate(22) scale(0.82)'>${PAW}</g>${extras}</g></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

export const effectivePawColor = (settings = {}) => normalizePawColor(activeHoliday(settings)?.pawColor || settings.pawColor);

export const pawStyle = (settings = {}) => ({
  "--paw-opacity": pawOpacity(settings.pawIntensity),
  "--paw-pattern": pawPattern(effectivePawColor(settings), activeHoliday(settings)?.bgIcon),
});
